// fadeOut takes an element and increases the opacity until it fades out
const FadeOut = function (elm) {
  const fadeEffect = setInterval(function () {
    if (!elm.style.opacity) {
      elm.style.opacity = 1;
    }
    if (elm.style.opacity > -0.3) {
      elm.style.opacity -= 0.1;
    } else {
      clearInterval(fadeEffect);
      elm.remove();
    }
  }, 30);
};

export default FadeOut;
